import axios from "axios";
import { apiKey, apiKeyAi } from "../../../store";
import {
  SET_FAILURE_MESSAGES,
  SET_LOADING_MESSAGES,
  SET_LIST_MESSAGES,
  SET_LOADING_DELETE,
  SET_FAILURE_DELETE,
  SET_SUCCESS_DELETE,
  SET_LIST_SESSION,
  SET_LOADING_SESSION,
  SET_FAILURE_SESSION,
  DELETE_SESSION_FROM_LIST,
} from "./listType";
import {
  DELETE_ALL_MESSAGES_IN_CHAT,
  SET_LOADING_CHAT,
} from "../chat/chatType";

const apiKeyMessages = apiKey + "conversations";
const apiKeySessions = apiKeyAi + "chat-sessions";

export const getMessages = async (authToken) => {
  return async (dispatch) => {
    dispatch({
      type: SET_LOADING_MESSAGES,
    });

    const config = {
      headers: {
        "Auth-Token": authToken,
        "X-Auth-Token": authToken,
        header_app_type: "client",
      },
      timeout: 15000,
    };

    const data = await axios.get(apiKeyMessages, config).catch((error) => {
      dispatch({
        type: SET_FAILURE_MESSAGES,
        payload: "عدم برقراری ارتباط با سرور",
      });
    });

    if (data) {
      if (data.data.success) {
        dispatch({
          type: SET_LIST_MESSAGES,
          payload: data.data.data,
        });

        return true;
      } else if (!data.data.success && data.data.errors) {
        dispatch({
          type: SET_FAILURE_MESSAGES,
          payload: data.data.errors[0].message,
        });
      }
    }
  };
};
export const getMessagesWithoutLoading = async (authToken) => {
  return async (dispatch) => {
    const config = {
      headers: {
        "Auth-Token": authToken,
        "X-Auth-Token": authToken,
        header_app_type: "client",
      },
      timeout: 15000,
    };

    const data = await axios.get(apiKeyMessages, config).catch((error) => {});

    if (data) {
      if (data.data.success) {
        dispatch({
          type: SET_LIST_MESSAGES,
          payload: data.data.data,
        });

        return true;
      }
    }
  };
};

export const getSessions = (authToken, page = null) => {
  return async (dispatch, getState) => {
    if (!page || page === 1) {
      dispatch({ type: SET_LOADING_SESSION });
    }
    const config = {
      headers: {
        "Auth-Token": authToken,
        "X-Auth-Token": authToken,
        header_app_type: "client",
      },
      timeout: 15000,
      params: {},
    };

    if (page) {
      config.params.page = page;
    }

    try {
      const res = await axios.get(apiKeySessions, config);

      if (res.data.success) {
        const newPayload = res.data;
        const { sessions } = getState().messages.list;
        const finalData =
          page && page > 1
            ? {
                ...newPayload,
                data: [...(sessions.data || []), ...newPayload.data],
              }
            : newPayload;

        dispatch({
          type: SET_LIST_SESSION,
          payload: finalData,
        });

        return true;
      } else if (res.data.errors) {
        dispatch({
          type: SET_FAILURE_SESSION,
          payload: res.data.errors[0].message,
        });
      }
    } catch (error) {
      dispatch({
        type: SET_FAILURE_SESSION,
        payload: "عدم برقراری ارتباط با سرور",
      });
    }
  };
};

// delete a chat

export const deleteChatMessages = (id, scope, authToken, session) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING_DELETE, payload: true });

    const config = {
      headers: {
        "Auth-Token": authToken,
        "X-Auth-Token": authToken,
        header_app_type: "client",
      },
      timeout: 15000,
    };

    const info = { scope };

    try {
      let url = "";
      if (session) {
        url = `${apiKeySessions}/${session}/delete`;
      } else {
        url = `${apiKeyMessages}/with/${id}/delete`;
      }
      const response = await axios.post(url, info, config);

      if (response.data.success) {
        dispatch({ type: SET_SUCCESS_DELETE, payload: id });
        dispatch({ type: DELETE_ALL_MESSAGES_IN_CHAT, payload: id });
        if (session) {
          dispatch({ type: DELETE_SESSION_FROM_LIST, payload: session });
        }
        return true;
      } else if (response.data.errors?.length) {
        dispatch({ type: SET_FAILURE_DELETE, payload: response.data.errors[0].message });
        setTimeout(() => {
          dispatch({ type: SET_FAILURE_DELETE, payload: null });
        }, 1100);
        return false;
      }
    } catch (error) {
      dispatch({ type: SET_FAILURE_DELETE, payload: "عدم برقراری ارتباط با سرور" });
      setTimeout(() => {
        dispatch({ type: SET_FAILURE_DELETE, payload: null });
      }, 1100);
      return false;
    }
  };
};
